import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      {/* Card-Bereich */}
      <div className="footer-inner">
        
        {/* Spalte 1: Logo */}
        <div className="footer-col">
          <img src={logo} alt="Stein & Wagner Logo" className="footer-logo" />
        </div>

        {/* Spalte 2: Navigation */}
        <div className="footer-col">
          <ul>
            <li>
              <Link to="/impressum">Impressum</Link>
            </li>
            {/* Datenschutzlink temporär entfernt */}
            {/* <li>
              <Link to="/datenschutz">Datenschutz</Link>
            </li> */}
          </ul>
        </div>

        {/* Spalte 3: placeholder */}
        <div className="footer-col"></div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        © 2025 Stein & Wagner – Alle Rechte vorbehalten
      </div>
    </footer>
  );
}